import React, { useEffect, useState, useCallback } from 'react'
import { toast } from 'react-toast'
import emailValidation from 'utils/emailValidation'
import { useTranslation } from 'react-i18next'
import Loader from 'components/Loader'
import { trackEvent } from 'utils/analytics1'

const SubscribeForm = ({ onValidated, status, message }) => {
  const [email, setEmail] = useState('')
  const { t } = useTranslation()

  useEffect(() => {
    if (!message) return

    if (status === 'success') {
      if (message.toString() == 'Thank you for subscribing!') {
        toast.success(message.toString())
      } else {
        toast.info(
          'Almost finished... To complete the subscription process, please confirm your email by clicking the link we sent to your email.',
          {
            backgroundColor: 'orange',
            color: '#ffffff'
          }
        )
      }
      trackEvent('Newsletter subscription', 'subscribe')
      setEmail('')
    } else toast.error(message.toString())
  }, [message, status])

  console.log(status)

  const onSubscribe = useCallback(
    e => {
      e.preventDefault()
      console.log(email)
      if (!email || !emailValidation(email)) {
        toast.error('Please enter a valid email address!')
        return
      }
      onValidated({
        EMAIL: email,
        MERGE1: '',
        MERGE2: ''
      })
    },
    [email, onValidated]
  )
  return (
    <div className="footerDetails">
      <h4> {t('c.subscribe')}</h4>
      <form>
        <div className="form-group">
          <input
            type="email"
            className="form-control"
            placeholder="Email address"
            value={email}
            onChange={e => setEmail(e.target.value)}
            style={{
              maxWidth: '350px'
            }}
          />
        </div>
        <button
          type="submit"
          className="btn btn-primary"
          disabled={status === 'sending'}
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            maxWidth: '350px'
          }}
          onClick={onSubscribe}
        >
          {t('c.subscribeButton')}
          {status === 'sending' && (
            <Loader
              style={{
                marginLeft: '10px'
              }}
            />
          )}
        </button>
      </form>
    </div>
  )
}

export default SubscribeForm
